import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PlanCurricularCampana from "./PlanCurricularCampana";
import PlanComercialCampana from "./PlanComercialCampana";
import ParametrosCampana from "./ParametrosCampana";

const RightPanel = styled.div`
  flex: 1;
  height: 100%;               
  display: flex;
  flex-direction: column;
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid #ddd;
`;

const Tab = styled.button`
  padding: 10px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 600;
  border-bottom: 3px solid
    ${({ active }) => (active ? "#3a87c8" : "transparent")};
  color: ${({ active }) => (active ? "#3a87c8" : "#555")};

    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

const Content = styled.div`
  flex: 1;                    
  overflow-y: auto;           
  padding: 20px;

  scrollbar-width: thin;
  scrollbar-color: #bbb transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 4px;
  }
`;

export default function ConfiguracionCampanas({ campana }) {
  const [tab, setTab] = useState("PLAN_CURRICULAR");

  useEffect(() => {
    setTab("PLAN_CURRICULAR");
  }, [campana]);

  return (
    <RightPanel>
      <Tabs>
        <Tab className={`nav-link font-gothan-medium ${tab === "PLAN_CURRICULAR" ? "active" : "nav-link-a"}`} active={tab === "PLAN_CURRICULAR"} onClick={() => setTab("PLAN_CURRICULAR")}>
          Plan Curricular
        </Tab>
        <Tab className={`nav-link font-gothan-medium ${tab === "META_COMERCIAL" ? "active" : "nav-link-a"}`} active={tab === "META_COMERCIAL"} onClick={() => setTab("META_COMERCIAL")}>
          Meta Comercial
        </Tab>
        <Tab className={`nav-link font-gothan-medium ${tab === "PARAMETROS" ? "active" : "nav-link-a"}`} active={tab === "PARAMETROS"} onClick={() => setTab("PARAMETROS")}>
          Parámetros
        </Tab>
      </Tabs>

      <Content>
        {tab === "PLAN_CURRICULAR" && <PlanCurricularCampana campana={campana} />}
        {tab === "META_COMERCIAL" && <PlanComercialCampana campana={campana} />}
        {tab === "PARAMETROS" && <ParametrosCampana campana={campana} isReadOnly={!campana?.PuedeEditarTabParametros}/>}
      </Content>
    </RightPanel>
  );
}
